import React from 'react'
import { FormControl, Select, MenuItem, Typography } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'

// Custom dropdown icon component that changes based on open state
const DropdownIcon = (props) => {
    return props.open ? <ExpandLessIcon {...props} sx={{ color: '#D1D5DB' }} /> : <ExpandMoreIcon {...props} sx={{ color: '#D1D5DB' }} />
}

const Dropdown = ({
    uniqueKey='',
    title,
    label,
    value,
    onChange,
    options = [],
    valueKey = 'value',
    labelKey = 'label',
    placeholder = '',
    disabled = false,
    fullWidth = true,
    fontSize = '14px',
    sx = {},
    ...props
}) => {
    // Ensure value is valid - must match one of the available options or be empty string
    const validOptions = options && Array.isArray(options)
        ? options.map(opt => opt && typeof opt === 'object' ? opt[valueKey] : opt).filter(v => v !== undefined)
        : []
    const safeValue = value !== undefined && value !== null ? value : ''
    const finalValue = validOptions.includes(safeValue) || safeValue === '' ? safeValue : ''

    return (
        <FormControl fullWidth={fullWidth} sx={sx}>
            {title ? (
                title
            ) : label ? (
                <Typography 
                    sx={{ 
                        fontSize: '14px',
                        fontWeight: 500,
                        color: '#374151',
                        mb: 1
                    }}
                >
                    {label}
                </Typography>
            ) : null}
            <Select
                value={finalValue}
                displayEmpty
                IconComponent={DropdownIcon}
                sx={{
                    backgroundColor: '#FFFFFF',
                    borderRadius: '6px',
                    fontSize: fontSize,
                    boxShadow: '0 1px 2px 0 rgb(0, 0, 0, 0.05)',
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#E5E7EB',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#D1D5DB',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#1F477D',
                        borderWidth: '2px',
                    },
                    '& .MuiSelect-select': {
                        padding: '12px 14px',
                        fontSize: fontSize,
                        color: finalValue !== '' ? '#111827' : '#9CA3AF',
                    },
                    '& .MuiSelect-icon': {
                        color: '#6B7280',
                        fontSize: '20px',
                        right: '12px',
                    },
                }}
                onChange={onChange}
                MenuProps={{
                    PaperProps: {
                        sx: {
                            borderRadius: '6px',
                            border: '1px solid #E5E7EB',
                            boxShadow: '0 1px 2px 0 rgb(0, 0, 0, 0.05)',
                            maxHeight: '200px',
                            marginTop: '4px',
                        },
                    },
                }}
                {...props}
            >
                {/* Always provide an empty option to prevent Select errors */}
                {(!options || options.length === 0 || placeholder) && (
                    <MenuItem disabled={!!placeholder} value="">
                        <Typography sx={{ color: '#9CA3AF', fontStyle: 'normal', fontSize: '14px' }}>
                            {placeholder || 'No options available'}
                        </Typography>
                    </MenuItem>
                )}
                {options && options.length > 0 && options.map((option) => (
                    <MenuItem
                        key={uniqueKey !== '' ? option[uniqueKey] : (option.id || option[valueKey])}
                        value={option[valueKey] !== undefined ? option[valueKey] : ''}
                        sx={{
                            fontSize: '14px',
                            color: '#111827',
                            '&:hover': {
                                backgroundColor: '#F9FAFB',
                            },
                            '&.Mui-selected': {
                                backgroundColor: '#EEF2FF',
                                '&:hover': {
                                    backgroundColor: '#E0E7FF',
                                },
                            },
                        }}
                    >
                        {option[labelKey] || ''}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}

export default Dropdown 